import React, { useEffect } from "react";
import { Instagram, Mail, Info } from "react-feather";
import StarRatings from "react-star-ratings";
import StickyNavbar from "components/StickyNavbar/StickyNavbar";
import ImageSection from "components/AboutMe/ImageSection";

import IOSFemale from "assets/images/ios-female.png";
import * as A from "./AboutMe.styles";
import * as G from "styles/General.Styles";
import InitialConsultationBox from "components/InitialConsultationBox/InitialConsultationBox";
import FooterNew from "components/FooterNew/FooterNew";
import TestimonialSlider from "components/TestimonialSlider/TestimonialSlider";
import Chip from "components/General/formComponents/chip/Chip";
import ApiCollections from "configs/services/apiCollections";
import * as CoachActions from "redux/coach/coach.actions";
import { useDispatch, useSelector } from "react-redux";
import { IS_LOCAL } from "configs/utils";
import { IMG_BASE_URL } from "pages/selectCoach/selectCoach";
import ReactPlayer from "react-player";
import SectionWrapper from "components/General/sectionWrapper/SectionWrapper";
import LeadSurveyModal from "modals/LeadSurveyModal/LeadSurveyModal";
import DefaultImage from "assets/images/default-foodiary-coach.png";

const AboutMe = () => {
  const dispatch = useDispatch();
  const coach = useSelector((state) => state.coach.coach);

  const [coachDetails, setCoachDetails] = React.useState({});
  const [coachProfile, setCoachProfile] = React.useState({});
  const [openLeadModal, setOpenLeadModal] = React.useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const coach_website_url = IS_LOCAL
      ? "https://ronja-fci49818.foodiary.app"
      : `${window.location.protocol}//${window.location.host}`;

    dispatch(
      CoachActions.trainerIdRequest({
        formData: { coach_website_url },
        callback: (res) => {
          dispatch(
            CoachActions.coachDataRequest({
              formData: { trainerID: res?.trainerID },
              callback: () => null,
            })
          );
        },
      })
    );
  }, [dispatch]);

  useEffect(() => {
    (async () => {
      // for testing purpose using id 1
      const [coachResponse, coachProfileResponse] = await Promise.all([
        ApiCollections.getCoachDetails({
          trainerID: coach?.trainerID || 1, // Default to 1 for testing
        }),
        ApiCollections.getCoachProfile({
          id: coach?.trainerID || 1, // Default to 1 for testing
        }),
      ]);
      setCoachDetails(coachResponse);
      setCoachProfile(coachProfileResponse);

      // Fetch coach details
    })();
  }, [coach?.trainerID]);
  console.log(coachDetails, "coachDetails");
  console.log(coachProfile, "coachProfile");

  function getAge() {
    if (!coachDetails?.data?.birthday) return "N/A";
    const birthDate = new Date(coachDetails?.data?.birthday);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }

  function getAverageRating() {
    if (!coachDetails?.coach_feedback?.length) return 0;
    const totalRating = coachDetails.coach_feedback.reduce(
      (sum, feedback) => sum + feedback.rating,
      0
    );
    return (totalRating / coachDetails.coach_feedback.length).toFixed(1);
  }

  function getTotalFeedback() {
    return coachDetails?.coach_feedback?.length || 0;
  }

  const handleModalOpen = () => {
    setOpenLeadModal(!openLeadModal);
  };
  console.log("====================================");
  console.log(coachDetails);
  console.log("====================================");
  return (
    <>
      <StickyNavbar openSurveyModal={() => setOpenLeadModal(!openLeadModal)} />
      <div className="overview-wrapper ">
        <A.OverviewWrapper>
          <div className="backColor" />
          <G.Container>
            <A.CardContainer>
              <ImageSection
                sm={true}
                imagePath={
                  coachDetails?.data?.profilePic
                    ? IMG_BASE_URL + coachDetails?.data?.profilePic
                    : ""
                }
              >
                <A.SocialButtons>
                  <A.IconButton
                    href={coachDetails?.data?.instagram_url}
                    target="_blank"
                  >
                    <Instagram size={20} />
                  </A.IconButton>
                  <A.IconButton
                    href={"mailto:" + coachDetails?.data?.foodiaryEmail}
                  >
                    <Mail size={20} />
                  </A.IconButton>
                  {/* <A.IconButton href={"https://www.foodiary.app/"}>
                  <Share2 size={20} />
                </A.IconButton> */}
                </A.SocialButtons>
              </ImageSection>

              <A.InfoCard>
                <A.Header>
                  <A.Name className="ct-headline color-dark font-medium">
                    {coachDetails?.data?.prename} {coachDetails?.data?.surname}
                  </A.Name>
                  <A.Reviews>
                    <img className="img" src={IOSFemale} />
                    <A.Age>{getAge()}</A.Age>
                    <A.AgeText>Jahre</A.AgeText>
                    {coachDetails?.coach_feedback?.length && (
                      <>
                        <A.ResponsiveStarRatings>
                          <StarRatings
                            rating={parseFloat(getAverageRating())}
                            starRatedColor="#FFD700"
                            numberOfStars={5}
                            starDimension="16px"
                            starSpacing="2px"
                          />
                        </A.ResponsiveStarRatings>
                        <span className="text-sm">
                          {getTotalFeedback()} Bewertungen
                        </span>
                      </>
                    )}
                  </A.Reviews>
                </A.Header>
                <A.BreakLine />

                <A.Grid>
                  <A.GridItem>
                    <A.GridTitle>Spezialgebiet</A.GridTitle>
                    <A.GridText className="text-lg">
                      {coachDetails?.data?.step1}
                    </A.GridText>
                  </A.GridItem>
                  <A.GridItem>
                    <A.GridTitle>Coach seit </A.GridTitle>
                    <A.GridText className="text-lg">
                      {coachDetails?.data?.step2}
                    </A.GridText>
                  </A.GridItem>
                  <A.GridItem>
                    <A.GridTitle>Aus/Weiterbildung</A.GridTitle>
                    <A.GridText className="text-lg">
                      {coachDetails?.data?.step3}
                    </A.GridText>
                  </A.GridItem>
                  <A.GridItem>
                    <A.GridTitle>Praxiserfahrung</A.GridTitle>
                    <A.GridText className="text-lg">
                      {coachDetails?.data?.step4}
                    </A.GridText>
                  </A.GridItem>
                </A.Grid>
                <A.BreakLine />

                {coachDetails?.trainer_qualification?.length
                  ? coachDetails?.trainer_qualification.map((item, index) => (
                      <A.Qualifications>
                        <h3>Meine Qualifikationen:</h3>
                        <A.QualificationItem>
                          <span>Abschluss: {item.year}</span>
                          <span className="border">|</span>
                          <span>Kind of: {item.qualification}</span>
                          <Info size={16} />
                        </A.QualificationItem>
                      </A.Qualifications>
                    ))
                  : null}

                <A.Button>
                  <button onClick={handleModalOpen} className="btn-dark">
                    Erstgespräch vereinbaren
                  </button>
                </A.Button>
              </A.InfoCard>
            </A.CardContainer>
          </G.Container>
        </A.OverviewWrapper>
      </div>
      <G.Container>
        <SectionWrapper margin="15rem 0" mobileMargin="7rem 0">
          <A.VideoSectionWrapper>
            <A.ContentGrid>
              <div>
                <Chip className="title" text="ÜBER MICH" />
                <A.ContentSectionTitle className="ct-headline color-dark font-medium">
                  Ich unterstütze dich mit meinem Ernährungscoaching.
                </A.ContentSectionTitle>
                <A.ContentSectionDescription>
                  {coachDetails?.data?.description}
                </A.ContentSectionDescription>
                <button onClick={handleModalOpen} className="btn-dark">
                  Erstgespräch vereinbaren
                </button>
              </div>
              <A.ContentChild>
                {coachDetails?.data?.pp_Intoduction_video_profilpage ? (
                  <A.VisualContent>
                    <A.VideoWrapper>
                      <ReactPlayer
                        url={
                          IMG_BASE_URL +
                          coachDetails?.data?.pp_Intoduction_video_profilpage
                        }
                        // playsinline
                        // playing
                        // muted
                        // loop
                        controls={true}
                        width="100%"
                        height="100%"
                        style={{
                          borderRadius: "20px",
                        }}
                      />
                    </A.VideoWrapper>
                  </A.VisualContent>
                ) : coachDetails?.data?.cw_lp_picture_1 ? (
                  <ImageSection
                    imagePath={
                      coachDetails?.data?.cw_lp_picture_1
                        ? IMG_BASE_URL + coachDetails?.data?.cw_lp_picture_1
                        : ""
                    }
                  />
                ) : (
                  <ImageSection imagePath={DefaultImage} />
                )}
              </A.ContentChild>
            </A.ContentGrid>
          </A.VideoSectionWrapper>
        </SectionWrapper>
      </G.Container>

      <A.ImagesSection>
        <G.Container>
          <A.ImageGrid>
            <A.ImageSectionParent>
              <A.SectionImage
                src={
                  coachDetails?.data?.pic_uber_mich_1
                    ? IMG_BASE_URL + coachDetails?.data?.pic_uber_mich_1
                    : DefaultImage
                }
                alt="Coach profile"
              />
            </A.ImageSectionParent>
            <A.ImageSectionParent>
              <A.SectionImage
                src={
                  coachDetails?.data?.pic_uber_mich_2
                    ? IMG_BASE_URL + coachDetails?.data?.pic_uber_mich_2
                    : DefaultImage
                }
                alt="Coach profile"
              />
            </A.ImageSectionParent>
            <A.ImageSectionParent>
              <A.SectionImage
                src={
                  coachDetails?.data?.pic_uber_mich_3
                    ? IMG_BASE_URL + coachDetails?.data?.pic_uber_mich_3
                    : DefaultImage
                }
                alt="Coach profile"
              />
            </A.ImageSectionParent>
            <A.ImageSectionParent>
              <A.SectionImage
                src={
                  coachDetails?.data?.pic_uber_mich_4
                    ? IMG_BASE_URL + coachDetails?.data?.pic_uber_mich_4
                    : DefaultImage
                }
                alt="Coach profile"
              />
            </A.ImageSectionParent>
          </A.ImageGrid>
        </G.Container>
      </A.ImagesSection>
      <G.Container>
        <SectionWrapper margin="15rem 0" mobileMargin="7rem 0">
          <A.BannerSection>
            <ImageSection
              imagePath={
                coachDetails?.data?.pic_uber_mich_5
                  ? IMG_BASE_URL + coachDetails?.data?.pic_uber_mich_5
                  : DefaultImage
              }
            />
            <A.BannerContent>
              <h5 className="font-medium ">
                {coachDetails?.data?.["3_fakten_headline_1"] ||
                  "Du erhältst meine Unterstützung"}
              </h5>
              <A.BannerText>
                {coachDetails?.data?.["3_fakten_text_1"] ||
                  "Als dein persönlicher Ernährungscoach für die kommenden 12 Wochen"}
              </A.BannerText>
              <A.BreakLine
                style={{
                  marginBottom: 15,
                }}
              />
              <h5 className="font-medium">
                {coachDetails?.data?.["3_fakten_headline_2"] ||
                  "Dein persönlicher Plan"}
              </h5>
              <A.BannerText>
                {coachDetails?.data?.["3_fakten_text_2"] ||
                  "Gemeinsam erstellen wir deinen persönlichen Plan mit über 1700 leckeren Rezepten"}
              </A.BannerText>
              <A.BreakLine
                style={{
                  marginBottom: 15,
                }}
              />
              <h5 className="font-medium">
                {coachDetails?.data?.["3_fakten_headline_3"] ||
                  "Diäten sind nicht der richtige Weg"}
              </h5>
              <A.BannerText>
                {coachDetails?.data?.["3_fakten_text_3"] ||
                  "Wenn dir Diäten seit Jahren nicht helfen, dann sind sie nicht die Lösung für deine Probleme"}
              </A.BannerText>

              <button
                onClick={handleModalOpen}
                className="btn-dark"
                style={{ marginTop: 20 }}
              >
                Erstgespräch vereinbaren
              </button>
            </A.BannerContent>
          </A.BannerSection>
        </SectionWrapper>
      </G.Container>
      <G.Container>
        <A.SliderTitle className="ct-headline color-dark font-medium">
          Das sagen zufriedene Teilnehmer
        </A.SliderTitle>
      </G.Container>
      <G.Container>
        <SectionWrapper margin="15rem 0" mobileMargin="7rem 0">
          <TestimonialSlider
            feedbackData={coachDetails?.coach_feedback || []}
            imageBaseUrl={IMG_BASE_URL}
          />
        </SectionWrapper>
      </G.Container>

      <SectionWrapper margin="15rem 0 0" mobileMargin="10rem 0 0">
        <InitialConsultationBox
          openLeadFormModal={() => setOpenLeadModal(true)}
        />
      </SectionWrapper>

      <FooterNew />
      {coach && (
        <LeadSurveyModal
          isOpen={openLeadModal}
          onClose={() => setOpenLeadModal(false)}
          coachProfile={coach}
        />
      )}
    </>
  );
};

export default AboutMe;
